<template>
  <div class="character">
    <div class="profile-state" :class='isCurrentUser ? "" : "small"'>
      <div class="avatar">
        <img :src="avatar" />
      </div>
      <div class="name">
        {{ name }}
      </div>
      <div class="status">
        <span class="thirst" v-if="is('thirsty')">
          [ THRISTY ]
        </span>
        <span class="hunger" v-if="is('hungry')">
          [ HUNGRY ]
        </span>
      </div>
      <div class="gold">
          <span class="amount">{{ gold }}</span>
          <div class="icon sm gold"></div>
      </div>
      <!--
      <div class="experience-meter" :class='isCurrentUser ? "" : "hidden"'>
        <span class="label">
          EXP:
        </span>
        <span class="counter">
          <b>{{ Math.round(experience) }}</b>
        </span>
      </div>
      -->
    </div>
  </div>
</template>

<script>

import ProgressBar from './ui/ProgressBar'

export default {
  name: 'Character',
  components: { ProgressBar },
  methods: {
    is (action) {
      return this.$store.state.player.status[action]
    }
  },
  data: () => {
    return {
      isCurrentUser: true
    }
  },
  computed: {
    name: that => that.$store.state.player.info.name,
    avatar: that => that.$store.state.player.info.avatar,
    gold: that => that.$store.state.player.gold,
    experience: that => that.$store.state.player.experience,

    thirstSpeed: function () {
      return -0.3
    },
    hungerSpeed: function () {
      return -0.3
    }
  }
}
</script>

<style scoped>
.character div {
}

.profile-state {
    min-height: 100px;
    background-color: rgba(0, 0, 0, .2);
    border-radius: 5px;
    padding: 5px;
    margin: 5px;
}
.profile-state .avatar {
    float: left;
    border-radius: 3px;
}

.profile-state .name {
    margin-left: 110px;
    font-size: 24px;
    text-transform: uppercase;
}
.profile-state .experience-meter {
    margin-left: 110px;
}
.profile-state .hunger-meter {
    margin-left: 110px;
}
.profile-state .thirst-meter {
    margin-left: 110px;
}
.profile-state .label {
    font-weight: bold;
}

.gold {
    margin: 4px;
}
.gold .amount {
    display: inline-block;
    margin: 6px 0;
}
.gold .icon {
    display: inline-block;
    border: none;
}

/* TEAM MEMBERS */
.team-state {
    position: fixed;
    top: 120px;
    left: 5px;
    width: 320px;
}
.team-state h3 {
    margin: 10px;
    padding: 0;
}

.profile-state.small {
    width: 300px;
}
.profile-state.small .avatar img {
    width: 60px;
    height: 60px;
}
.profile-state.small .name {
    margin-left: 70px;
    font-size: 18px;
    text-transform: uppercase;
}
.profile-state.small .experience-meter {
    margin-left: 70px;
    font-size: 12px;
}
.profile-state.small .hunger-meter {
    margin-left: 70px;
    font-size: 12px;
}
.profile-state.small .thirst-meter {
    margin-left: 70px;
    font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Character.vue